export enum BusinessPolicyDiscountType {
  VALUE = 'VALUE',
  PERCENTAGE = 'PERCENTAGE',
  FIXED_VALUE_FROM_PERCENTAGE = 'FIXED_VALUE_FROM_PERCENTAGE',
}
